import { ArrowDownward, ArrowDownwardSharp } from "@mui/icons-material";
import {
  Box,
  Button,
  ButtonGroup,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  InputAdornment,
  InputLabel,
  MenuItem,
  Radio,
  RadioGroup,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { FaArrowDown, FaArrowUp, FaClock } from "react-icons/fa";
import { positionList } from "../../constant/positionList";

const processElapsedTime = (msValue) => {
  const date = new Date(msValue);
  const hh = date.getUTCHours();
  const mm = date.getUTCMinutes();
  const ss = ("0" + date.getUTCSeconds()).slice(-2);
  const ms = ("00" + date.getUTCMilliseconds()).slice(-3);
  return `${hh}:${("0" + mm).slice(-2)}:${ss}.${ms}`;
};

const SubtitionModal = ({
  onClose,
  open,
  teamADetails,
  teamBDetails,
  teamAPlayers,
  teamBPlayers,
  teamAPlayerSubs,
  teamBPlayerSubs,
  currentTime,
  onUpdate,
}) => {
  const [team, setTeam] = useState("A");
  const [outPlayer, setOutplayer] = useState("");
  const [inPlayer, setInplayer] = useState("");

  const players = (team === "A" ? teamAPlayers : teamBPlayers)?.filter(
    (n) => n !== outPlayer && n !== inPlayer
  );

  const subsPlayers = (
    team === "A" ? teamAPlayerSubs : teamBPlayerSubs
  )?.filter((n) => n !== outPlayer && n !== inPlayer);

  useEffect(() => {
    if (!open) {
      setOutplayer("");
      setInplayer("");
    }
  }, [open]);
  return (
    <Dialog
      PaperProps={{
        sx: {
          minWidth: "40vw", // 👈 set your desired min width here
        },
      }}
      sx={{ width: "100%" }}
      maxWidth="xl"
      open={open}
      onClose={onClose}
    >
      <DialogTitle
        sx={{ fontFamily: "Poppins", fontSize: "12px", color: "#121213" }}
      >
        Substitution Details
      </DialogTitle>
      <DialogContent>
        <Stack direction="row" justifyContent="center" alignItems="center">
          <RadioGroup
            row
            sx={{ gap: 5, justifyContent: "center" }}
            aria-labelledby="team-selection"
            defaultValue="A"
            name="team-selection-buttons-group"
          >
            <FormControlLabel
              value="A"
              checked={team === "A"}
              onClick={() => {
                setTeam("A");
                setOutplayer("");
                setInplayer("");
              }}
              control={<Radio size="small" />}
              componentsProps={{ typography: { component: "div" } }}
              label={
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                >
                  <Typography
                    sx={{ fontSize: "12px", fontWeight: "700" }}
                    variant="body1"
                    lineHeight={1.2}
                  >
                    {teamADetails?.name}
                  </Typography>
                  <Typography
                    sx={{ fontSize: "10px", fontWeight: "400" }}
                    variant="caption"
                    color="text.secondary"
                    lineHeight={1.5}
                  >
                    Team A
                  </Typography>
                </Box>
              }
              sx={{
                alignItems: "flex-end", // Align radio to the top of label content
              }}
            />
            <FormControlLabel
              value="B"
              checked={team === "B"}
              onClick={() => {
                setTeam("B");
                setOutplayer("");
                setInplayer("");
              }}
              control={<Radio size="small" />}
              componentsProps={{ typography: { component: "div" } }}
              label={
                <Box
                  display="flex"
                  flexDirection="column"
                  alignItems="flex-start"
                >
                  <Typography
                    sx={{ fontSize: "12px", fontWeight: "700" }}
                    variant="body1"
                    lineHeight={1.2}
                  >
                    {teamBDetails?.name}
                  </Typography>
                  <Typography
                    sx={{ fontSize: "10px", fontWeight: "400" }}
                    variant="caption"
                    color="text.secondary"
                    lineHeight={1.5}
                  >
                    Team B
                  </Typography>
                </Box>
              }
              sx={{
                alignItems: "flex-end", // Align radio to the top of label content
              }}
            />
          </RadioGroup>
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <CustomSelectInput
            required
            label="Player Out"
            placeholder="Jr No."
            value={outPlayer}
            onChange={(e) => setOutplayer(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <FaArrowDown size="12" color="#ff0000dd" />
              </InputAdornment>
            }
          >
            {players?.map((player) => (
              <MenuItem value={player}>{player}</MenuItem>
            ))}
          </CustomSelectInput>
          {/* <CustomSelectInput
            placeholder="Current position"
            value=""
            label="Position"
          >
            {positionList?.map((pos) => (
              <MenuItem value={pos?.id}>{pos?.alias}</MenuItem>
            ))}
          </CustomSelectInput> */}
        </Stack>
        <Stack
          mt={2}
          gap={5}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          {/* <Stack
            gap={1}
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Typography
              sx={{ fontSize: "12px", color: "#888E99", textAlign: "right" }}
            >
              In Time:
            </Typography>
            <TimeBox color="#055641" time={processElapsedTime(currentTime)} />
          </Stack> */}
          <Stack
            gap={1}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Typography
              sx={{ fontSize: "12px", color: "#888E99", textAlign: "left" }}
            >
              Out Time:
            </Typography>
            <TimeBox color="#9B1C1C" time={processElapsedTime(currentTime)} />
          </Stack>
        </Stack>
        <Divider sx={{ my: 2 }} />
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={2}
        >
          <CustomSelectInput
            required
            label="Player In"
            placeholder="Jr No."
            value={inPlayer}
            onChange={(e) => setInplayer(e.target.value)}
            startAdornment={
              <InputAdornment position="start">
                <FaArrowUp size="12" color="#00ff00dd" />
              </InputAdornment>
            }
          >
            {subsPlayers?.map((player) => (
              <MenuItem value={player}>{player}</MenuItem>
            ))}
          </CustomSelectInput>
          {/* <CustomSelectInput
            placeholder="Current position"
            value=""
            label="Position"
          >
            {positionList?.map((pos) => (
              <MenuItem value={pos?.id}>{pos?.alias}</MenuItem>
            ))}
          </CustomSelectInput> */}
        </Stack>
        <Stack
          mt={2}
          gap={5}
          direction="row"
          justifyContent="center"
          alignItems="center"
        >
          <Stack
            gap={1}
            direction="row"
            justifyContent="flex-end"
            alignItems="center"
          >
            <Typography
              sx={{ fontSize: "12px", color: "#888E99", textAlign: "right" }}
            >
              In Time:
            </Typography>
            <TimeBox color="#055641" time={processElapsedTime(currentTime)} />
          </Stack>
          {/* <Stack
            gap={1}
            direction="row"
            justifyContent="flex-start"
            alignItems="center"
          >
            <Typography
              sx={{ fontSize: "12px", color: "#888E99", textAlign: "left" }}
            >
              Out Time:
            </Typography>
            <TimeBox color="#9B1C1C" time="0:00" />
          </Stack> */}
        </Stack>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          gap={1}
          mt={2}
        >
          <Button
            onClick={onClose}
            variant="outlined"
            size="medium"
            sx={{ textTransform: "none", flex: 1, borderRadius: "8px" }}
            color="info"
          >
            Cancel
          </Button>
          <Button
            disabled={!outPlayer || !inPlayer}
            onClick={() => {
              onUpdate({
                team,
                time: currentTime,
                outPlayer: outPlayer,
                inPlayer: inPlayer,
              });
              onClose();
            }}
            variant="contained"
            size="medium"
            sx={{ textTransform: "none", flex: 1, borderRadius: "8px" }}
            color="info"
          >
            Add Substitution
          </Button>
        </Stack>
        <Typography sx={{ fontSize: "12px", color: "#A9ADB4", mt: 1 }}>
          <span style={{ color: "red" }}>*</span> Required Fields
        </Typography>
      </DialogContent>
    </Dialog>
  );
};

export default SubtitionModal;

const TimeBox = ({ time, color = "#055641" }) => (
  <Box
    sx={{
      bgcolor: color + "20",
      borderRadius: "6px",
      px: 1,
      py: 0.2,
      gap: 0.5,
    }}
    display="flex"
    flexDirection="row"
    justifyContent="center"
    alignItems="center"
  >
    <FaClock size="12px" color={color} />
    <Typography
      sx={{
        fontSize: "12px",
        color: color,
        fontWeight: "500",
        textAlign: "center",
      }}
    >
      {time || "0:00"}
    </Typography>
  </Box>
);

const CustomSelectInput = ({
  required,
  label,
  value,
  onChange,
  children,
  startAdornment,
  placeholder,
}) => (
  <FormControl sx={{ marginTop: 2 }} fullWidth>
    <InputLabel
      sx={{
        marginTop: -2,
        transform: "none",
        position: "static",
        mb: 0.5,
        fontSize: "12px",
        color: "#12121390",
        fontWeight: "500",
      }}
      shrink
    >
      {label}
      {required && <span style={{ color: "red" }}>*</span>}
    </InputLabel>
    <Select
      displayEmpty
      renderValue={(selected) =>
        selected === "" ? (
          <span style={{ color: "#999", fontSize: "12px" }}>{placeholder}</span>
        ) : (
          selected
        )
      }
      startAdornment={startAdornment}
      sx={{ borderRadius: "8px" }}
      size="small"
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={value}
      onChange={onChange}
    >
      <MenuItem value="" disabled>
        {placeholder}
      </MenuItem>
      {children}
    </Select>
  </FormControl>
);
